var $ = jQuery;
$(function () {
  // Options
  var selector = ".shortcode-read-more-less";
  var selector__content = "".concat(selector, "__content");
  var selector__button = "".concat(selector, "__button");
  var buttonText = {
    hidden: 'Read more',
    visible: 'Read less'
  };
  $(selector__button).on('click', function (e) {
    $button = $(this);
    $el = $(this).closest(selector);
    $content = $el.find(selector__content);
    var initialState = $el.attr('data-state');
    var newState = initialState == 'hidden' ? 'visible' : 'hidden';
    $el.attr('data-animating', true);
    $button.trigger('blur');
    $content.slideToggle(function () {
      $el.attr('data-state', newState);
      $el.attr('data-animating', false);
    });
  });
});